import { useOverlays } from "contexts/OverlayContext";
import { TransactionViewDrawer } from "./TransactionViewDrawer";

export const GlobalTransactionViewDrawer = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("globalTransactionView");

    if (!overlayInfo || !overlayInfo.data) {
        return null;
    }

    return (
        <TransactionViewDrawer
            {...overlayInfo.data}
            open={!overlayIsClosing}
            onClose={closeOverlay}
        />
    );
};
